export default {
  namespaced: true,
  maintenance: {
    field_name: "Field name",
    field: "field",
    move: "Move",
    cancel: "Cancel",
    move_above: "Move above",
    move_below: "Move below",
    moving: "Moving:",
    move_to_top: "Move to top",
    move_to_bottom: "Move to bottom",
    unknown_field: "Unknown field",
    confirm_delete_item: "Are you sure you want to delete the item?",
    visibility: "Visibility",
    conditional: "Make conditional",
    previous_question: "Previous question...",
    select_placeholder: "Select...",
    clear: "Clear",
    always_visible: "No conditions: this field is always visible.",
    auto_fill: "Autofill",
    enable: "Enable",
    action_to_apply: "Action to apply",
    copy_reference_value: "Copy the reference field value",
    apply_new_value: "Apply a new value",
    copy_other_value: "Copy a value from another field",
    overwrite_on_save: "Overwrite on save (overwrite)",
    value_to_apply: "Value to apply (new_value)",
    enter_value: "Enter the value...",
    field_to_copy: "Field to copy",
    select_other_field: "Select another field...",
    auto_fill_note: "Note: this will be evaluated at runtime using the selected operator.",
    no_auto_fill: "No rules: this field is not autofilled.",
    contains: "Contains",
    empty: "Empty",
    not_empty: "Not empty",
    search_text: "Text to search for...",
    value_placeholder: "Value...",
    can_crop: "Allow cropping",
    file_upload: {
      paste_image: "Paste an image here with Ctrl+V",
      images: "images",
      minimum: "minimum {min}",
      min_images_required: "You must add at least {min} images.",
    },
    media_config: {
      min_required: "Minimum is required",
      max_required: "Maximum is required",
      min_non_negative_integer: "Minimum must be a positive integer or zero",
      max_greater_than_zero: "Maximum must be greater than zero",
      min_not_greater_than_max: "Minimum cannot be greater than maximum",
      max_not_less_than_min: "Maximum cannot be less than minimum",
    },
    title: "Maintenance",
    maintenance_crew: "Maintenance Crew",
    maintenance_companies: "Maintenance Companies",
    maintenance_templates: "Maintenance Templates",
    maintenance_forms: "Maintenance Forms",
    name:"Name",
    address:"Address",
    manager_name:"Manager Name",
    manager_plate:"Manager phone",
    country_name:"Country",
    site: "Site",
    document_number: "Document number",
    facility: "Facility",
    select: "Select",
    multiple_select: "Multiple Select",
    camera: "Camera",
    asset: "Asset",
    text_answer: "Text answer",
    format: "Format",
    short_answer: "Short answer",
    paragraph: "Paragraph",
    checkbox: "Checkbox",
    date_time: "Date & time",
    media: "Media",
    slider: "Slider",
    min: "Minimum",
    max: "Maximum",
    increment: "Increment",
    annotation: "Annotation",
    signature: "Signature",
    location: "Location",
    instruction: "Instruction",
    field_types: "Field types",
    field_type_config: "Field type config",
    preview: "Preview",
    date: "Date",
    time: "Time",
    required: "Required",
    show_in_app: "Show in App",
    question: "Question",
    type_response: "Type of response",
    go_back: "Go back",
    create_template: "Create template",
    update_template: "Update template",
    template_name: "Template name",
    form_name: "Form name",
    add_new_field: "Add new field",
    add_new_fileds: "Add new fields",
    template:'Template',
    addForm: 'add form',
    addTemplate: 'add template',
    serviceOrder: 'service order',
    add_new_fields: 'No fields added',
    choose_an_option: 'Choose an option',
    select: 'Select',
    number: 'Number',
    number_config: {
      min: 'Minimum',
      max: 'Maximum',
      help_text: 'Number (minimum, maximum)',
      min_must_be_less_than_max: 'Minimum must be less than maximum',
      max_must_be_greater_than_min: 'Maximum must be greater than minimum',
      must_be_between: '{field} must be between {min} and {max}.',
    },
    form_validations: {
      name: 'Set a name for this field',
      type: 'Set a type for this field',
    },
    messages: {
      created_success: 'Item Created successfully',
      updated_success: 'Item Updated successfully',
    },
    crew: {
      description: 'Description',
      leader: 'Leader',
      users: 'Users',
      company: 'Company'
    },
    status: {
      pending: 'Pending',
      in_review: 'In review',
      in_progress: 'In progress',
      finished: 'Finished',
      canceled: 'Canceled',
      latest_status: 'Last status',
    },
    maintenance_form: "Maintenance Form",
    export: "Export",
  }
}
